<template>
    <div>
        <message v-for="message in messages" :message="message" :key="message.id" :owner="owner" />
    </div>
</template>
<script>

    import Message from './Message.vue';

    export default {
        components: {
            Message
        },
        props: ['messages', 'owner']
    }

</script>